import "./Item.scss";
import "../../assets/Button/ButtonShop/ButtonShop";
import logo from "../../image/logotype/logo.svg";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../cart/CartContext";
import React from "react";

export default function Item(props) {
  const [toggleState, setToggleState] = useState(1);
  const { add } = useCart();

  const getActiveSku = () => {
    const skus = [props.skuFirst, props.skuSecond, props.skuThird, props.skuFourth];
    return skus[toggleState - 1] || props.skuFirst || props.sku;
  };

  const toggleTab = (index) => setToggleState(index);

  const parsePrice = (str) => Number(String(str).replace(/[^\d]/g, "")) || 0;

  const getActiveUnit = () => {
    const units = [props.unitFirst, props.unitSecond, props.unitThird, props.unitFourth];
    return units[toggleState - 1] || "";
  };

  const getActivePrice = () => {
    const prices = [props.priceFirst, props.priceSecond, props.priceThird, props.priceFourth];
    return parsePrice(prices[toggleState - 1]);
  };

  const getActiveImg = () => {
    const imgs = [props.imgFirst, props.imgSecond, props.imgThird, props.imgFourth];
    return imgs[toggleState - 1] || props.imgFirst || null;
  };

  const handleAdd = () => {
    const unit = getActiveUnit();
    const price = getActivePrice();
    const img = getActiveImg();
    const sku = getActiveSku();


    add({
      sku,
      title: props.title,
      price,
      img,
      unit,
      quantity: 1
    });
  };

  return (
    <div className={"item " + (props.isNew && "item--new") + " " + (props.InStock && "item--stock")}>
      <div className="item__row">
        <div className="item__title">
          <Link to={props.inside}>
            <span className="title">{props.title}</span>
          </Link>
          <span className="item__new-arr">НОВИНКА!</span>
        </div>

        <div className="item__wrapper">
          <div className="item__image-container">
            <div className="item__image">{props.imgUrl}</div>
          </div>

          <div className="item__center">
            <div className="item__block">
              <img className="item__logo" src={logo} alt="logo" />
              <span className="item__factory-text">Виробник:</span>
              <span className="item__factory-name">Санберрі Україна</span>
            </div>

            <div className="item__zone">
              <div className="item__packing">
                <span className="item__packing-text">Фасування:</span>
                <div className="item__packing-position">
                  <div className="item__capacity-tabs">
                    <button
                      className={toggleState === 1 ? "item__cap-tabs active-item__cap-tabs" : "item__cap-tabs"}
                      onClick={() => toggleTab(1)}
                    >
                      {props.unitFirst}
                    </button>
                    <button
                      className={toggleState === 2 ? "item__cap-tabs active-item__cap-tabs" : "item__cap-tabs"}
                      onClick={() => toggleTab(2)}
                    >
                      {props.unitSecond}
                    </button>
                    <button
                      className={toggleState === 3 ? "item__cap-tabs active-item__cap-tabs" : "item__cap-tabs"}
                      onClick={() => toggleTab(3)}
                    >
                      {props.unitThird}
                    </button>
                    <button
                      className={toggleState === 4 ? "item__cap-tabs active-item__cap-tabs" : "item__cap-tabs"}
                      onClick={() => toggleTab(4)}
                    >
                      {props.unitFourth}
                    </button>
                  </div>
                </div>
              </div>

              <div className="item__price">
                <div className="price__charts">
                  <span className="price__item">Роздрібна ціна</span>
                </div>

                <div className="price item__capacity-tabs-active">
                  <div className={toggleState === 1 ? "capacity active-capacity" : "capacity"}>
                    {props.priceFirst}
                  </div>
                  <div className={toggleState === 2 ? "capacity active-capacity" : "capacity"}>
                    {props.priceSecond}
                  </div>
                  <div className={toggleState === 3 ? "capacity active-capacity" : "capacity"}>
                    {props.priceThird}
                  </div>
                  <div className={toggleState === 4 ? "capacity active-capacity" : "capacity"}>
                    {props.priceFourth}
                  </div>
                </div>

                <div className={"item__stock " + (props.InStock && "item__stock--new")}>
                  <span className="item__stock-arr">в наявності</span>
                  <span className="item__stock-road">немає в наявності</span>
                </div>

                <div className="item__suborder">
                  <div className="item__order">
                    <button className="btn-detail--shop" onClick={handleAdd}>До кошика</button>
                  </div>
                  <Link to={props.inside}>
                    <p className="item__desc">Детальніше</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
